import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})
export class ProceduresService {

    constructor(private http: HttpClient) {
    }

    createProcedure(procedureData: object) {
        return this.http.post('/api/createProcedure', procedureData);
    }

    getProcedureById(id: string) {
        return this.http.get('/api/getProcedureById?procedureId=' + id);
    }

    getAllProcedures() {
        return this.http.get('/api/allProcedures');
    }

    getMainIdProcedures() {
        return this.http.get('/api/getMainIdProcedures');
    }

    updateProcedure(id: string, procedureData: object) {
        return this.http.put('/api/updateProcedure?procedureId=' + id, procedureData);
    }

    changeProcedureStatus(id: string, status: string) {
        return this.http.put('/api/changeProcedureStatus?procedureId=' + id + '&status=' + status, {});
    }

    addProcedureConsent(id: string, accept: boolean) {
        return this.http.put('/api/addProcedureConsent?procedureId=' + id + '&accept=' + accept, {});
    }

    isUserInConsentList(id) {
        return this.http.get('/api/isInProcedureConsentList?procedureId=' + id);
    }
    teamMembersNotInProcedureConsent(id) {
        return this.http.get('/api/teamMembersNotInProcedureConsent?procedureId=' + id);
    }


}
